import React from "react";
var __jsx = React.createElement;
import Accordion from "@componentsShared/Tailwind/Accordion/Accordion";
import useBoolean from "@hooks/useBoolean";
import { useTranslation } from "@i18n";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
import { useLang } from "@/common/Contexts/LanguageContext";
import { If } from "@componentsShared/Conditional/If";
var BrandCommonQuestion = function BrandCommonQuestion(_ref) {
  var title = _ref.title,
    questions = _ref.questions;
  var accordionList = useBoolean();
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var IS_SSR = __IS_SSR__;
  var _useSearchResultsData = useSearchResultsData(),
    contextFaqQuestions = _useSearchResultsData.faqQuestions;
  var faqQuestions = questions || contextFaqQuestions;
  var commonQuestions = function commonQuestions() {
    if (!accordionList.value && !IS_SSR) {
      return faqQuestions.slice(0, 3);
    } else {
      return faqQuestions;
    }
  };

  // Return empty if there are NO questions
  if (!(faqQuestions !== null && faqQuestions !== void 0 && faqQuestions.length)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-primary-old font-bold text-base leading-12"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-8"
  }, /*#__PURE__*/React.createElement(Accordion, null, commonQuestions().map(function (item, index) {
    var question = lang === 'ar' ? item === null || item === void 0 ? void 0 : item.question_ar : item === null || item === void 0 ? void 0 : item.question_en;
    var answer = lang === 'ar' ? item === null || item === void 0 ? void 0 : item.answer_ar : item === null || item === void 0 ? void 0 : item.answer_en;
    return /*#__PURE__*/React.createElement(Accordion.Item, {
      background: "bg-white",
      defaultOpen: index === 0,
      key: "accordion-".concat(index),
      className: "filter drop-shadow-[0_1px_4.4px_rgba(0,0,0,0.08)] rounded-lg border-none px-4 py-3"
    }, /*#__PURE__*/React.createElement(Accordion.Title, {
      className: "text-xs font-bold text-primary-old text-start p-0 cursor-pointer",
      iconContainerClassName: "ar:left-0 en:right-0"
    }, question), /*#__PURE__*/React.createElement(Accordion.Body, {
      className: "flex-col gap-3 p-0 pt-2 text-[#5E5E5E] text-xs font-normal leading-6"
    }, answer));
  })), /*#__PURE__*/React.createElement(If, {
    condition: (faqQuestions === null || faqQuestions === void 0 ? void 0 : faqQuestions.length) > 4
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex justify-center"
  }, /*#__PURE__*/React.createElement("button", {
    className: "text-primary-old w-32 h-9 px-2 py-1 font-bold rounded border border-solid border-primary-old inline-flex justify-center items-center gap-2.5 bg-white md:text-sm cursor-pointer",
    onClick: accordionList.toggle
  }, /*#__PURE__*/React.createElement(Conditional, {
    condition: accordionList.value
  }, /*#__PURE__*/React.createElement(Then, null, tShort("faq/show_less", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement(Else, null, tShort("faq/show_more", {
    ns: "web_search"
  })))))))));
};
export default BrandCommonQuestion;